(function(){
  'use strict';

  angular.module('tf.retailer.Util')
      .provider('UtilCacheProvider', CacheFactoryProvider);

  function CacheFactoryProvider() {

    this.$get = function () {
      var caches = {};

      function cacheProvider(cacheId, options) {
        var size = 0,
            config = _.extend({}, options, {id: cacheId}),
            data = {},
            lruObj = {},
            freshEnd = null,
            staleEnd = null;

        // validate options
        _validateCapacity(config.capacity);
        _validateMaxAge(config.maxAge);

        // Set the default capacity
        if (!config.capacity) {
          config.capacity = Number.MAX_VALUE;
        }

        /**
         * @method _validateCapacity
         * @desc Validates the capacity.
         * @param capacity: Integer
         */
        function _validateCapacity(capacity) {
          if (config.capacity) {
            if (!_.isNumber(config.capacity)) throw new Error('capacity must be a number');
            if (config.capacity < 0) throw new Error('capacity must be greater than zero');
          }
        }

        /**
         * @method _validateMaxAge
         * @desc Validates the maxAge.
         * @param maxAge: Integer
         */
        function _validateMaxAge(maxAge) {
          if (maxAge) {
            if (!_.isNumber(maxAge)) throw new Error('maxAge must be a number');
            if (maxAge < 0) throw new Error('maxAge must be greater than zero');
          }
        }

        /**
         * @method refresh
         * @desc Makes the `entry` the freshEnd of the LRU linked list.
         * @param entry : Object {}
         */
        function _refresh(entry) {
          if (entry !== freshEnd) {
            if (!staleEnd) {
              staleEnd = entry;
            } else if (staleEnd === entry) {
              staleEnd = entry.next;
            }

            _link(entry.next, entry.prev);
            _link(entry, freshEnd);
            freshEnd = entry;
            freshEnd.next = null;
          }
        }

        /**
         * @method link
         * @desc Bidirectionally links two entries of the LRU linked list
         * @param nextEntry: Object
         * @param prevEntry: Object
         */
        function _link(nextEntry, prevEntry) {
          if (nextEntry !== prevEntry) {
            if (nextEntry) {
              nextEntry.prev = prevEntry;
            }
            if (prevEntry) {
              prevEntry.next = nextEntry;
            }
          }
        }

        /**
         * @method cacheProvider.put
         * @param key: string => The identifier for the item to add to the cache.
         * @param value: any => The value of the item to add to the cache.
         * @returns The value of the item added to the cache.
         */
        this.put = function (key, value) {
          var lruEntry = lruObj[key] || (lruObj[key] = {key: key}),
              self = this;

          _refresh(lruEntry);

          if (_.isUndefined(value)) return;

          if (!(key in data)) size++;

          data[key] = {
            value: value
          };

          if (config.maxAge) {
            data[key].timestamp = new Date().getTime();
            if (data[key].timeoutId) {
              clearTimeout(data[key].timeoutId);
            }
            data[key].timeoutId = setTimeout(function () {
              self.remove(key);
            }, config.maxAge);
          }

          if (size > config.capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        };

        /**
         * @method cacheProvider.get
         * @param key: string The key of the item to retrieve.
         * @returns The value of the item in the cache with the specified key.
         */
        this.get = function (key) {
          var lruEntry = lruObj[key];

          if (!lruEntry) return;

          _refresh(lruEntry);

          return data[key].value;
        };

        /**
         * @method cacheProvider.remove
         * @desc Remove the specified key-value pair from this cache.
         * @param key: String => The key of the key-value pair to remove.
         */
        this.remove = function (key) {
          var lruEntry = lruObj[key];

          if (!lruEntry) {
            return;
          }

          if (lruEntry === freshEnd) {
            freshEnd = lruEntry.prev;
          }
          if (lruEntry === staleEnd) {
            staleEnd = lruEntry.next;
          }
          _link(lruEntry.next, lruEntry.prev);

          delete lruObj[key];
          delete data[key];
          size--;
        };

        /**
         * @method cacheProvider.removeAll
         * @desc Clear this cache.
         */
        this.removeAll = function () {
          data = {};
          size = 0;
          lruObj = {};
          freshEnd = staleEnd = null;
        };

        /**
         * @method cacheProvider.destroy
         * @desc Completely destroy this cache.
         */
        this.destroy = function () {
          data = null;
          config = null;
          lruObj = null;
          delete caches[cacheId];
        };

        /**
         * @method cacheProvider.info
         * @returns Object containing config information about this cache.
         *
         */
        this.info = function () {
          return _.extend({}, config, {size: size});
        };
      }

      /**
       * @class cacheFactory
       * @param cacheId : string => The id of the new cache.
       * @param [options] { capacity: {number}, maxAge: {number} }
       * @returns {cacheProviderObjects}
       */
      function cacheFactory(cacheId, options) {
        if (cacheId in caches) {
          throw new Error('cacheId ' + cacheId + ' already exist');
        } else if (!_.isString(cacheId)) {
          throw new Error('cacheId must be a string!');
        }

        caches[cacheId] = new cacheProvider(cacheId, options);
        return caches[cacheId];
      }

      /**
       * @method cacheFactory.info
       * @returns object containing information about all caches of this factory.
       */
      cacheFactory.info = function () {
        var info = {};
        _.forEach(caches, function (cache, cacheId) {
          info[cacheId] = cache.info();
        });
        return info;
      };

      /**
       * @method advancedCacheFactory.get
       * @param {string} cacheId The id of the desired cache.
       * @returns {cacheProviderObject} The cache with the specified cachedId.
       */
      cacheFactory.get = function (cacheId) {
        return caches[cacheId];
      };

      cacheFactory.removeAll = function () {
        _.each(caches, function (cache) {
          cache.removeAll();
        })
      };

      return cacheFactory;
    };
  }

})();